import axios from '../api/axiosInstance';

export const fetchOrderStatusReport = (params = {}) => {
  return axios.get('/reports/orders/status', { params });
};

export const fetchOrderShopReport = (params = {}) => {
  return axios.get('/reports/orders/shops', { params });
};
